import { ForwardedRef, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export interface ScrollToCommentData {
	commentId?: string;
	commentRef?: ForwardedRef<HTMLDivElement>;
	scrollToAction?: () => void;
	highlightColor?: string;
}

export const useScrollToComment = (): ScrollToCommentData => {
	const location = useLocation();
	const commentRef = useRef<null | HTMLDivElement>(null);

	let commentId = undefined;
	const params = new URLSearchParams(location.search);
	const queryCommentId = params.get('comment_id');

	// Supports two URL formats:
	// 1. http://localhost:3003/bonuses/ID?comment_id=CHILD_BONUS_ID
	// 2. http://localhost:3003/bonuses/CHILD_BONUS_ID
	if (queryCommentId) {
		commentId = queryCommentId;
	} else if (location.hash) {
		commentId = /\/bonuses\/([a-z0-9]+)/.test(location.pathname) ? location.hash.substring(1) : undefined;
	}

	if (commentId)
		return {
			commentId,
			commentRef,
			scrollToAction: () => commentRef.current?.scrollIntoView({ behavior: 'smooth' }),
			highlightColor: 'lightyellow',
		};
	else return {};
};
